import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodeshipComponent } from './simple-icons-codeship.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodeshipComponent ],
    exports:      [ SimpleIconsCodeshipComponent ],
    bootstrap:    []
})
export class SimpleIconsCodeshipModule {}
